import LearnitTagResourceModel from '../../generated/types/model/resource/LearnitTagResourceModel';

export default class LearnitTagResourceViewModel extends LearnitTagResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
